import axios from 'axios'
import {API_URL} from '../constants';

const MATERIAL_API_URL = `${API_URL}/materials`;

class MaterialService {

    fetchMaterials() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_API_URL}/`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchMaterialByBatchNo(batchNo) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_API_URL}/${batchNo}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return {};
        });
    }

    fetchMaterialCode(code) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MATERIAL_API_URL}/${code}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return {};
        });
    }

    updateQuantity(item) {
        let info = {
            id: item.id,
            quantity: item.quantity,
            batchNo: item.batchNo
        }
        const token = sessionStorage.getItem('token');
        return axios.put(`${MATERIAL_API_URL}/${item.id}`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchMaterialStocks(page, pageSize, fromDate, toDate, searchMaterial, searchModifiedBy) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_API_URL}/by`,  {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate, material: searchMaterial, modifiedBy: searchModifiedBy},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    updateProfileXi(item) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MATERIAL_API_URL}/updateProfileXi`, item,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }       
}

export default new MaterialService();
